import type {SchemaService, ComponentFeature} from '@wix/document-services-types'
import _ from 'lodash'
import type {SingleComponentPluginFunction} from '../../types'
import {PROPERTIES_TO_PRESERVE} from './constants'
import {type ReferredDataItemsIterateeContext, forEachReferredDataItem} from '@wix/import-export-utils'
import {COMPONENT_FEATURES} from '@wix/format-converter-schemas'

const removeDefaults = (defaults: Record<string, any>, toModify: Record<string, any>) => {
    const defaultProperties = _.without(_.keys(defaults), ...PROPERTIES_TO_PRESERVE)
    for (const property of defaultProperties) {
        if (_.isEqual(toModify[property], defaults[property])) {
            delete toModify[property]
        }
    }
}

export const pack: SingleComponentPluginFunction = (rawComponent: any, schemaService: SchemaService) => {
    const {data, structure} = rawComponent
    const defaultStructure = schemaService.createItemAccordingToSchema(structure.type, 'structure')
    removeDefaults(defaultStructure, structure)

    _.forOwn(COMPONENT_FEATURES, ({namespace, alias}: ComponentFeature) => {
        const dataItem = data[alias]
        if (!dataItem) {
            return
        }

        forEachReferredDataItem(
            schemaService,
            dataItem,
            namespace,
            ({item, namespace: itemNamespace}: ReferredDataItemsIterateeContext) => {
                const defaultItem = schemaService.createItemAccordingToSchema(item.type, itemNamespace)
                removeDefaults(defaultItem, item)
            }
        )
    })
}
